import React from 'react';

import Slider from '@crehana/ui/dist/Slider';
import { Container } from '@crehana/ui/dist/GridV2';

import { FeaturesSectionProps } from './types';
import { FeaturesSectionItem } from './components';

const FeaturesSection: React.FC<
  React.PropsWithChildren<FeaturesSectionProps>
> = ({ features }) => (
  <section className="bg-base-main text-white pb-360 pt-112">
    <Container>
      <div className="flex justify-end mb-16">
        <div className="default-pagination-features" />
      </div>
      <Slider
        dark
        desktopPaginationSelector=".default-pagination-features"
        itemsPerPage={{
          lg: 4,
          md: 4,
          sm: 2,
          xs: 1,
        }}
      >
        {features.map(feature => (
          <div key={feature.id} className="px-20">
            <FeaturesSectionItem feature={feature} />
          </div>
        ))}
      </Slider>
    </Container>
  </section>
);

export default FeaturesSection;
